// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"7cbbcd58","315":"f6633801","427":"70023c6a","463":"0bbc2e4a","925":"d38a6edc"}[chunkId] + ".chunk.js";
};